/**
 * Verdict-form badge visibility, kept here (not inline in ExpertReviewPage) so
 * the privacy-relevant defaults are unit-testable without a component renderer.
 *
 * A verdict can be unwelcome ("don't ship this"), so the public Xpert Verified
 * badge must never be published unless the expert deliberately ticks the
 * toggle, which they should do only with the buyer's agreement. This matches
 * the backend default (`VerificationVerdictCreate.is_public_badge = False`).
 */

export const DEFAULT_PUBLIC_BADGE = false;

/**
 * Consent wording for the "publish a public badge" toggle. Shared by both
 * verdict forms (ExpertReviewPage and VerdictSubmitPage) so the expert sees
 * the same words wherever they submit.
 */
export const PUBLIC_BADGE_CONSENT_LABEL =
  "Publish a public Xpert Verified badge (buyer must have agreed)";
export const PUBLIC_BADGE_CONSENT_HELP =
  "Tick only if the buyer has agreed to a public /verified/{slug} page. Left off, the badge stays private and the buyer still receives your full verdict.";

/**
 * Where to send the expert after a verdict is saved.
 *
 * A private badge has no public page: GET /api/badges/{slug} returns 404 for
 * anything that is not public. So only a badge that came back public lands on
 * /verified/{slug}; everything else goes to the expert dashboard.
 */
export function postVerdictPath(result) {
  if (result && result.badge_slug && result.is_public === true) {
    return `/verified/${result.badge_slug}`;
  }
  return "/expert-dashboard";
}
